import { validate } from "../../helpers/validate.js";
import { attributesCodeBlockSchema } from "./attributes.js";
import { guideCodeBlockHtml } from "./component.js";
import { ScalarCodeBlockVue } from "./component.js";
import { parseCodeBlockMeta } from "./helpers.js";
import { nanoid } from "@scalar-org/entities/utility";
import { parseCodeBlockMeta as parseCodeBlockMeta2 } from "../../elements/index.js";
import { withDataAttrFallback } from "../../helpers/attributes-with-data-fallback.js";
import { hydrate } from "./hydration.js";
const scalarCodeBlock = {
  name: "scalar-code",
  tagName: "scalar-code",
  tiptapName: "custom_code_block",
  attributeTransform: (_, _attrs) => {
    const attrs = withDataAttrFallback(_attrs);
    const parsedMeta = typeof attrs.meta === "string" ? parseCodeBlockMeta2(attrs.meta) : {};
    const validated = validate(attributesCodeBlockSchema, {
      ...parsedMeta,
      // ---------------------------------------------------------------------------
      // We consider the presence of the fullHeight attribute, regardless of its value, to
      // indicate that fullHeight is true. This allows for usage like fullHeight="false"
      // to explicitly disable it while still being recognized as true.
      lang: attrs.lang || "plaintext",
      // ---------------------------------------------------------------------------
      // Adding a unique ID to each code block allows us to use the ids when
      // the code blocks are inside a code group
      id: attrs.id || nanoid()
    });
    return validated;
  },
  render: async (props) => {
    return guideCodeBlockHtml(props);
  },
  hydrate
};
export {
  ScalarCodeBlockVue,
  parseCodeBlockMeta,
  scalarCodeBlock
};
//# sourceMappingURL=index.js.map
